import { ReactNode } from "react"
import { Outlet } from "react-router-dom"
import { Header } from "./header"
import { Footer } from "./footer"



interface FrontLayoutProps {
    children?: ReactNode
}



export const FrontLayout = ({ ...props }: FrontLayoutProps) => {


    return <div className=" bg-primary-50 ">
        <Header />
        {props.children || <Outlet />}
        <Footer />
    </div>
} 